import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  Label,
} from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { getFans } from "store/actions/athletesAction";
import { Input } from "reactstrap/es";
import { toast } from "react-toastify";
import moment from "moment";
import SearchBar from "components/SearchBar";
import { searchFansOrAthletes } from "store/actions/athletesAction";
import OnlyHeader from "components/Headers/OnlyHeader";
import { sendFanEmail } from "store/actions/athletesAction";

const SchoolFans = () => {
  const csvLink = useRef(null);
  const dispatch = useDispatch();

  const { uid, user } = useSelector((state) => state.auth);
  console.log(user);
  const {
    schoolFans,
    isLoading,
    loadmoreLoader,
    fansLastDocument,
    fansMoreDocuments,
  } = useSelector((state) => state.athletes);

  const [selectedRows, setSelectedRows] = useState([]);
  const [modal, setModal] = useState(false);
  const [searchId, setSearchId] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [url, setUrl] = useState("");
  const [agreeEmail, setAgreeEmail] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const areAllFieldsFilled = () => {
    return selectedRows.every(
      (row) => row.allotment && row.setPercentage && row.expireDate
    );
  };

  const handleCSVDownload = (e) => {
    if (!areAllFieldsFilled()) {
      e.preventDefault();
      toast.error("All fields are required");
    } else {
      setModal(false);
      setTimeout(() => {
        setSelectedRows([]);
      }, 2000);
    }
  };

  const handleCheckboxChange = (item) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.some((row) => row.id === item.id)) {
        return prevSelectedRows.filter((row) => row.id !== item.id);
      } else {
        return [...prevSelectedRows, item];
      }
    });
  };

  const handleLoadMore = () => {
    if (user?.instituteName && fansLastDocument) {
      dispatch(
        getFans({
          school: user?.instituteName,
          lastDocument: fansLastDocument,
          prevData: schoolFans,
        })
      );
    }
  };

  const handleInputChange = (id, field, value) => {
    const regex = /^[0-9]*$/;
    if (field !== "expireDate" && !regex.test(value)) {
      return;
    }
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  const handleInput = (e) => {
    const value = e.target.value;
    if (/^[F\d]*$/.test(value)) {
      setSearchId(value);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const trimmedValue = searchId.trim();
    let payload = {
      id: searchId,
      role: "fan",
      state: user?.state,
      city: user?.county,
      school: user?.instituteName,
    };
    if (trimmedValue && user?.instituteName) {
      setSearchLoader(true);
      await dispatch(
        searchFansOrAthletes(payload, (data) => {
          setSearchData(data);
          setSearchId("");
          setSearchLoader(false);
        })
      );
    }
    setSearchLoader(false);
  };

  console.log("user: ", user);
  useEffect(() => {
    if (user?.instituteName) {
      dispatch(
        getFans({
          school: user?.instituteName,
          lastDocument: null,
          prevData: [],
        })
      );
    }
  }, []);
  const [fanEmail, setFanEmail] = useState("");
  const [fanEmailText, setFanEmailText] = useState("");
  const [fanEmailModal, setFanEmailModal] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const toggleEmailModal = () => {
    setFanEmailModal(!fanEmailModal);
    setFanEmailText("");
    setUrl("");
  };

  const handleSendFanEmail = (email) => {
    setFanEmail(email);
    toggleEmailModal();
  };

  const handleSentEmail = (e) => {
    e.preventDefault();

    const urlPattern = /^(https?:\/\/|www\.)[^\s/$.?#].[^\s]*$/;

    let data = {
      message: fanEmailText,
      fanEmail: fanEmail,
      schoolAdminId: uid,
      url: url,
    };

    if (fanEmailText === "") {
      toast.error("Please add email content");
    } else if (url && !urlPattern.test(url)) {
      toast.error("Please enter a valid URL");
    } else {
      setBtnLoader(true);
      dispatch(
        sendFanEmail(data, () => {
          toggleEmailModal();
          setFanEmail("");
          setBtnLoader(false);
          setUrl("");
        })
      );
    }
  };

  return (
    <>
      <OnlyHeader />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 ">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h3 className="mb-0 whitespace-nowrap">Email Apps</h3>
                  <div className="d-flex justify-content-end align-items-center">
                    {!isLoading && user && (
                      <>
                        <Button
                          color="primary"
                          disabled={selectedRows.length === 0}
                          onClick={() => toggleModal()}
                          className="whitespace-nowrap"
                        >
                          Export CSV
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <SearchBar
                  searchId={searchId}
                  handleInput={handleInput}
                  handleSearch={handleSearch}
                  searchLoader={searchLoader}
                />
              </CardHeader>
              {isLoading && user ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <Table
                    className="align-items-center table-flush mb-3"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Select</th>
                        <th scope="col">ID</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchData.length > 0 ? (
                        searchData.map((item) => (
                          <tr key={item?.id}>
                            <td className="d-flex">
                              <Input
                                className="mx-2 position-relative"
                                type="checkbox"
                                checked={selectedRows.some(
                                  (row) => row.id === item.id
                                )}
                                onChange={() => handleCheckboxChange(item)}
                              />
                            </td>
                            <td>{item?.fanID}</td>
                            <td>{item?.name}</td>
                            <td>{item?.email}</td>
                            <td>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => handleSendFanEmail(item?.email)}
                              >
                                Spread sheets
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : schoolFans.length > 0 ? (
                        schoolFans.map((item) => (
                          <tr key={item?.id}>
                            <td className="d-flex">
                              <Input
                                className="mx-2 position-relative"
                                type="checkbox"
                                checked={selectedRows.some(
                                  (row) => row.id === item.id
                                )}
                                onChange={() => handleCheckboxChange(item)}
                              />
                            </td>
                            <td>{item?.fanID}</td>
                            <td>{item?.name}</td>
                            <td>{item?.email}</td>
                            <td>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => handleSendFanEmail(item?.email)}
                              >
                                Email
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {fansMoreDocuments && searchData.length === 0 && (
                    <div className="w-100 d-flex justify-content-center my-3">
                      {" "}
                      <Button
                        color="primary"
                        size="sm"
                        disabled={!fansMoreDocuments}
                        onClick={handleLoadMore}
                      >
                        {loadmoreLoader ? <Spinner size="sm" /> : "LoadMore"}
                      </Button>
                    </div>
                  )}
                  {searchData.length > 0 && (
                    <div className="w-100 d-flex justify-content-center my-3">
                      {" "}
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          setSearchData([]);
                          setSearchId("");
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  )}
                </>
              )}
            </Card>
          </div>
        </Row>

        <Modal isOpen={modal} toggle={toggleModal} size="lg">
          <ModalBody>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">FHP Id</th>
                  <th scope="col">Fan Name</th>
                  <th scope="col">Allotment</th>
                  <th scope="col">Set Percentage</th>
                  <th scope="col">Expire Date</th>
                </tr>
              </thead>
              <tbody>
                {selectedRows.length > 0 ? (
                  selectedRows?.map((item) => {
                    return (
                      <tr key={item?.id}>
                        <td>{item?.fanID}</td>
                        <td>{item?.name}</td>
                        <td className="d-flex">
                          <Input
                            name="allotment"
                            value={item?.allotment || ""}
                            type="text"
                            placeholder="100"
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "allotment",
                                e.target.value
                              )
                            }
                            required
                          />
                        </td>
                        <td>
                          <Input
                            name="setPercentage"
                            value={item?.setPercentage || ""}
                            type="text"
                            placeholder="10%"
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "setPercentage",
                                e.target.value
                              )
                            }
                            required
                          />
                        </td>
                        <td>
                          <Input
                            name="expireDate"
                            value={item?.expireDate || ""}
                            type="date"
                            min={moment().format("YYYY-MM-DD")}
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "expireDate",
                                e.target.value
                              )
                            }
                            required
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td>N/A</td>
                    <td>N/A</td>
                    <td>N/A</td>
                    <td>N/A</td>
                    <td>N/A</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <CSVLink
              ref={csvLink}
              headers={[
                { label: "FAN_NAME", key: "FAN_NAME" },
                { label: "FHP_ID", key: "FHP_ID" },
                { label: "ALLOTMENT", key: "ALLOTMENT" },
                { label: "SET", key: "SET" },
                { label: "EXPIRE_DATE", key: "EXPIRE_DATE" },
              ]}
              filename={`SchoolFans.csv`}
              data={
                selectedRows == -1
                  ? []
                  : selectedRows.map((item) => {
                      return {
                        ...item,
                        FAN_NAME: item?.name,
                        FHP_ID: item?.fanID,
                        ALLOTMENT: item?.allotment,
                        SET: item?.setPercentage + "%",
                        EXPIRE_DATE: `'${moment(item?.expireDate).format(
                          "MM/DD/YYYY"
                        )}'`,
                      };
                    })
              }
              className={`ml-auto btn btn-primary text-nowrap ${
                selectedRows.length === 0 ? "disabled" : ""
              }`}
              onClick={handleCSVDownload}
            >
              Export
            </CSVLink>
            <Button onClick={toggleModal}>Cancel</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={fanEmailModal} toggle={toggleEmailModal} size="md">
          <Form onSubmit={handleSentEmail}>
            <ModalBody>
              {/* <h3 className="text-center">Enter Email Text For Fan</h3> */}
              <div>
                <p>
                  {user.type == "collective" ? (
                    <b>
                      <p>
                        <b> Dear Sports Fan Registered at FHP,</b>
                      </p>
                      We see that one of our Partner Collectives recruits for
                      the SAME SCHOOL as one of your FAVORITE SCHOOLS as you
                      indicated on FHP site. That Collective is interested to
                      email you a message. The message is attached.
                    </b>
                  ) : (
                    <b>
                      <p>
                        <b>Dear Sports Fan Registered at FHP,</b>
                      </p>
                      We see that one of your FAVORITE SCHOOLS is interested to
                      email you a message. The message is attached
                    </b>
                  )}
                </p>
                <Input
                  type="textarea"
                  placeholder="Enter message"
                  value={fanEmailText}
                  onChange={(e) => setFanEmailText(e.target.value)}
                  required
                />
                <div className="mt-2">
                  <div className="d-flex mt-2 ml-4">
                    <Input
                      required
                      type="checkbox"
                      className="custom-checkbox"
                      checked={agreeEmail}
                      onChange={(e) => setAgreeEmail(e.target.checked)}
                    />
                    <Label className=" mx-4 mt-1">
                      On behalf of our organization, we agree to publicize
                      FansHelpPlayers ads to our fan base in exchange for
                      FansHelpPlayers sending the link we provide to their fans
                      who indicate our School is their favorite.
                    </Label>
                  </div>
                  <Label htmlFor="url">
                    Here is our UR: link to teach new fans about our
                    organization:
                  </Label>
                  <Input
                    id="url"
                    type="text"
                    placeholder="Enter Url"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    required
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="danger"
                onClick={toggleEmailModal}
                disabled={btnLoader}
              >
                Close
              </Button>
              <Button
                color="primary"
                type="submit"
                disabled={btnLoader || !agreeEmail}
              >
                {btnLoader ? <Spinner size="sm" /> : "Send"}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Container>
    </>
  );
};

export default SchoolFans;
